var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyCertificates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.32,42.48c-0.26,1-1.04,1.79-2.02,2.06c-1.4,0.38-1.13,0.29-1.55,0.49V56.2l-6.25-3.13l-6.25,3.13V45.03 c-0.42-0.2-0.15-0.11-1.55-0.49c-0.99-0.27-1.76-1.05-2.02-2.06c-0.53-2.02-0.39-1.77-1.84-3.25c-0.72-0.74-1-1.81-0.74-2.81 c0.53-2.01,0.53-1.73,0-3.75c-0.26-1,0.02-2.08,0.74-2.81c1.45-1.48,1.31-1.22,1.84-3.25c0.26-1,1.04-1.79,2.02-2.06 c1.97-0.54,1.74-0.39,3.19-1.88c0.72-0.73,1.78-1.02,2.76-0.75c1.98,0.54,1.7,0.54,3.69,0c0.99-0.27,2.04,0.02,2.76,0.75 c1.45,1.48,1.21,1.34,3.19,1.88c0.99,0.27,1.76,1.05,2.02,2.06c0.53,2.02,0.39,1.77,1.84,3.25c0.72,0.74,1,1.81,0.74,2.81 c-0.53,2.02-0.53,1.74,0,3.75c0.26,1.01-0.02,2.08-0.74,2.81C29.71,40.71,29.85,40.45,29.32,42.48z M25.75,34.32 c0-3.45-2.8-6.25-6.25-6.25s-6.25,2.8-6.25,6.25c0,3.45,2.8,6.25,6.25,6.25S25.75,37.77,25.75,34.32z M57,19.08v32.43 c0,2.59-2.11,4.69-4.69,4.69H28.88v-4.69h23.44V23.39H42.15c-1.3,0-2.34-1.04-2.34-2.34V10.89H24.19v7.8H19.5v-7.8 c0-2.59,2.1-4.69,4.69-4.7h19.93c1.24,0,2.43,0.5,3.31,1.38l8.19,8.19C56.5,16.64,57,17.84,57,19.08z M51.93,18.7l-7.43-7.43v7.43 H51.93z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCertificates);
export default __webpack_public_path__ + "static/media/my_certificates.11ca2134efab1f18d48048421aa036c2.svg";
export { ForwardRef as ReactComponent };